<template>
<div>
  <b-tooltip :label="$t('button.fullscreen')" position="is-left">
      <img
        @click="fullscreen"
        style="width:16px;margin-right:10px;cursor:pointer"
        src="@/assets/img/icons/full-screen.png"
        alt="full-screen-icon"
      />
  </b-tooltip>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'ButtonFullScreen',

  methods: {
    ...mapMutations({
      vueFullscreen: 'TOGGLE_VUE_RESULTATS_FULLSCREEN'
    }),
    fullscreen () {
      var elem = document.documentElement
      if (!this.sondage_vue_fullscreen) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen()
        }
      }
      this.vueFullscreen()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/components/ButtonFullScreen.vue